import React, { useEffect } from "react";
import { useGlobalContext } from "../../context/globalContext";
import History from "../../History/History";
import { InnerLayout } from "../../styles/Layouts";
import { dollar } from "../../utils/Icons";
import Chart from "../Chart/Chart";
import "./Dashboard.css"; // Import the CSS file

function Dashboard({ setActive }) { // ✅ Accept setActive as prop
  const {
    totalExpenses,
    incomes,
    expenses,
    totalIncome,
    totalBalance,
    getIncomes,
    getExpenses,
  } = useGlobalContext();


  

  useEffect(() => {
    if (localStorage.getItem("token")) {
        getIncomes();
        getExpenses();
    }
}, []);

  return (
    <div className="dashboard">
      <InnerLayout>
        <h1>
          DASHBOARD
        </h1>
        <div className="stats-con">
          <div className="chart-con">
            <Chart className="chart" />
            <div className="amount-con">
              <div className="income">
                <h2>Total Income</h2>
                <p>
                  {dollar} {totalIncome()}
                </p>
              </div>
              <div className="expense">
                <h2>Total Expense</h2>
                <p>
                  {dollar} {totalExpenses()}
                </p>
              </div>
              <div className="balance">
                <h2>Total Balance</h2>
                <p>
                  {dollar} {totalBalance()}
                </p>
              </div>
            </div>
          </div>
          <div className="history-con">
          <div 
              className="history-scroll" 
              onClick={() => setActive(2)} // ✅ Change active tab to History
              style={{ cursor: "pointer" }}
            >
              <History isDashboard={true} noPadding limitTransactions={true} />
            </div>
            <h2 className="salary-title">
              Min <span>Salary</span>Max
            </h2>
            <div className="salary-item">
              <p>${Math.min(...incomes.map((item) => item.amount))}</p>
              <p>${Math.max(...incomes.map((item) => item.amount))}</p>
            </div>
            <h2 className="salary-title">
              Min <span>Expense</span>Max
            </h2>
            <div className="salary-item">
              <p>${Math.min(...expenses.map((item) => item.amount))}</p>
              <p>${Math.max(...expenses.map((item) => item.amount))}</p>
            </div>
          </div>
        </div>
      </InnerLayout>
    </div>
  );
}

export default Dashboard;
